import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { useCitationCreate } from '@/module/Author/Citation/model/CitationQuery';
import { CitationSchema, citationSchema, defaultCitationValues } from '@/module/Author/Citation/model/CitationSchema';

import { useAppNotification } from '@feature/utils';

import { CitationForm } from './CitationForm';

interface CitationCreateProps {
  publicationId: number;
}

export function CitationCreate({ publicationId }: CitationCreateProps) {
  const { t } = useTranslation();
  const { mutate, isPending, isError, isSuccess } = useCitationCreate(publicationId);
  const navigate = useNavigate();
  const notification = useAppNotification();

  const onSubmit = (values: CitationSchema) => {
    mutate(values, {
      onError: notification.error,
      onSuccess: () => {
        notification.success();
        navigate({ to: '..' });
      },
    });
  };

  return (
    <CitationForm
      title={t('citations.form.title.create')}
      schema={citationSchema}
      defaultValues={defaultCitationValues}
      values={undefined}
      isSubmitting={isPending}
      isError={isError}
      isSuccess={isSuccess}
      onSubmit={onSubmit}
      onCancel={() => navigate({ to: '..' })}
      showWosFields={false}
      showScopusFields={false}
    />
  );
}
